import { TopTenOnOSNPlusPosterArtTray } from '../../../domain/top-ten-on-osn-plus-poster-art-tray';
import {
  CreateTopTenVodContentPageItemRequestApiModel,
  TopTenVodContentPageItemApiModel,
  UpdateTopTenVodContentPageItemRequestApiModel,
} from '@cxb/editor-stb-api';
import { mapperPipe, remainderMapper } from 'osn-shared';
import {
  displayServiceTypeIconMapperDomainToApi,
  nameLocalizedMapperDomainToApi,
  scheduledDateMapperDomainToApi,
  targetingMapperDomainToApi,
} from '../../mapping/create-tray-domain-to-api';
import {
  commonMapper,
  dthStatusMapper,
  nameLocalizedMapperApiToDomain,
  scheduledDateMapperApiToDomain,
  targetingMapperApiToDomain,
} from '../../mapping/create-tray-api-to-domain';
import { TopTenOnOSNPlusPosterArtTrayFormViewModel } from './top-ten-on-osn-plus-poster-art-tray-form.view-model';
import { TrayFormViewModelType } from '../view-model-common/view-model-type';
import {
  displayServiceTypeIconMapper,
  nameLocalizedMapperDomainToViewModel,
  scheduledDateMapperDomainToViewModel,
  targetingMapper,
} from '../create-tray-screen/mapping/create-tray-domain-to-vm';
import {
  nameLocalizedMapperViewModelToDomain,
  scheduledDateMapperViewModelToDomain,
} from '../create-tray-screen/mapping/create-tray-vm-to-domain';

// 'TopTenOnOSNPlusPosterArtTray'

/**
 * DOMAIN -> API
 */

export const mapTopTenOnOSNPlusPosterArtTrayDomainModelToApiModel = (
  item: TopTenOnOSNPlusPosterArtTray,
  pageVersionId?: string,
  tenantId?: string
): CreateTopTenVodContentPageItemRequestApiModel & UpdateTopTenVodContentPageItemRequestApiModel => {
  const commonProperties = mapperPipe(
    item,
    nameLocalizedMapperDomainToApi,
    targetingMapperDomainToApi,
    displayServiceTypeIconMapperDomainToApi,
    scheduledDateMapperDomainToApi
  );

  // eslint-disable-next-line sonarjs/no-identical-functions
  return remainderMapper(commonProperties, () => ({
    pageVersionId,
    feedId: item.feedId,
    tenantId,
  }));
};

/**
 * API -> DOMAIN
 */

export const mapTopTenOnOSNPlusPosterArtTrayApiModelToDomainModel = (
  topTenVodContent: TopTenVodContentPageItemApiModel
): TopTenOnOSNPlusPosterArtTray => {
  return remainderMapper(
    mapperPipe(
      topTenVodContent,
      commonMapper,
      nameLocalizedMapperApiToDomain,
      targetingMapperApiToDomain,
      scheduledDateMapperApiToDomain,
      displayServiceTypeIconMapperDomainToApi,
      dthStatusMapper
    ),
    () => ({
      type: 'TopTenOnOSNPlusPosterArtTray',
      feedId: topTenVodContent.feedId,
    })
  );
};

/**
 * DOMAIN -> VIEWMODEL
 */

export const mapTopTenOnOSNPlusPosterArtTrayDomainModelToViewModel = (
  value: TopTenOnOSNPlusPosterArtTray
): TopTenOnOSNPlusPosterArtTrayFormViewModel => {
  const commonProperties = mapperPipe(
    value,
    commonMapper,
    nameLocalizedMapperDomainToViewModel,
    targetingMapper,
    scheduledDateMapperDomainToViewModel,
    displayServiceTypeIconMapper
  );

  return remainderMapper(commonProperties, () => ({
    type: TrayFormViewModelType.TopTenOnOSNPlusPosterArt, // AXB-82
    feedId: value.feedId,
  }));
};

/**
 * VIEWMODEL -> DOMAIN
 */

export const mapTopTenOnOSNPlusPosterArtTrayViewModelToDomainModel = (
  vm: TopTenOnOSNPlusPosterArtTrayFormViewModel
): TopTenOnOSNPlusPosterArtTray => {
  const commonProperties = mapperPipe(
    vm,
    commonMapper,
    nameLocalizedMapperViewModelToDomain,
    targetingMapper,
    scheduledDateMapperViewModelToDomain,
    displayServiceTypeIconMapper
  );

  return remainderMapper(commonProperties, () => ({
    type: 'TopTenOnOSNPlusPosterArtTray', // AXB-82
    feedId: vm.feedId,
  }));
};
